var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hideShow",on:{"click":_vm.changeVisibility}},[(_vm.visibility)?_c('span',[_vm._v("Hide")]):_c('span',[_vm._v("Show")])])}
var staticRenderFns = []

export { render, staticRenderFns }